import {alias, createModelSchema} from "serializr";
import {BranchModel} from "@/modules/mconfigs/models/BranchModel";
import {ConfigModel} from "@/modules/mconfigs/models/ConfigModel";

export default class BranchConfigsModel {
    constructor(branch, config) {
        this._branch = branch;
        this._config = config;
    }

    get branch() {
        return this._branch;
    }

    set branch(value) {
        this._branch = value;
    }

    get config() {
        return this._config;
    }

    set config(value) {
        this._config = value;
    }
}

createModelSchema(BranchConfigsModel, {
  _branch: alias("branch", BranchModel.schema()),
  _groups: alias("config", ConfigModel.schema()),
});